module.exports = __webpack_public_path__ + "img/hero-vs_pow21.8a349c5.jpg";